import Logo from './logo.png'
import PDF from './PDF_icon.svg'

const icons = {
  Logo,
  PDF
}

export default icons
